<app-layout>
  <app-voltar route="listagem/desengates" />
  <div class="headerForm">
    <div class="title">
      <app-titulo>Desengate</app-titulo>
    </div>
    <div class="espacamento"></div>
  </div>

  <div class="forms">
    <form [formGroup]="form" (ngModelChange)="clearForms()">
      <div class="formList">
        <app-input
          type="number"
          label="N° do Agendamento"
          name="FK_AGND"
          formControlName="FK_AGND"
          placeholder="Digite aqui"
          [requiredInput]="true"
          (blurEvent)="getAgendamento()"></app-input>
        <app-input
          type="text"
          label="Placa do Cavalo"
          name="TX_PLCA_CAVA"
          placeholder="Digite aqui"
          formControlName="TX_PLCA_CAVA"
          mask="AAA-0A00"
          [requiredInput]="true"
          (blurEvent)="getAgendamento()"></app-input>
        <app-input
          type="disabled"
          label="Motorista"
          placeholder="Aguardando"
          name="NM_MTRT"
          formControlName="NM_MTRT"></app-input>
        <app-input
          *ngIf="isViewing"
          type="disabled"
          label="O que foi desengatado:"
          placeholder="Nenhuma carreta"
          name="PLCA_DSGT"
          formControlName="PLCA_DSGT"></app-input>
        <app-select-check
          *ngIf="!isViewing"
          type="select"
          label="Carretas que serão desengatadas do cavalo"
          [placeholder]="carretasDesengatadas"
          (ngModelChange)="onSairChange($event)"
          [selectData]="sairOptions"></app-select-check>
        <app-input
          type="disabled"
          label="Carretas que permanecerão engatadas no cavalo"
          name="TX_ESTC"
          formControlName="TX_ESTC"
          [selectData]="estacionamentoOptions"></app-input>
        <app-input
          type="textarea"
          class="grid-2fr"
          label="Observação"
          name="TX_OBSV_ENGT_DSGT"
          formControlName="TX_OBSV_ENGT_DSGT"
          placeholder="Digite aqui"></app-input>
      </div>
      <div *ngFor="let i; in: sairOptions">
        <h1 *ngIf="i.selecionado === true">{{ i.name }}</h1>
      </div>
      <app-botao
        *ngIf="!isViewing"
        type="cadastro"
        class="botao-cadastro"
        [text]="isEditing ? 'Editar Desengate' : 'Registrar Desengate'"
        [disabled]="!form.valid"
        (click)="saveDesengate()"></app-botao>
    </form>
  </div>
</app-layout>

<app-loader [isLoading]="isLoading"></app-loader>
